module.exports = __webpack_public_path__ + "static/img/web_home_4.164f68c.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/extensionPage/web_home_4.png
// module id = sD1A
// module chunks = 0